import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M14.233 6.818c0 .452.367.818.818.818H33A7.364 7.364 0 0 1 40.364 15v18.02a.818.818 0 1 0 1.636 0V15a9 9 0 0 0-9-9H15.051a.82.82 0 0 0-.818.818M8.017 36.223q-.38-4.86-.38-9.743 0-4.877.38-10.16a4.09 4.09 0 0 1 4.096-3.797q5.547.023 9.456.023 3.889 0 9.796-.023c2.26-.008 4.098 1.816 4.107 4.107a2571 2571 0 0 0 0 19.258 4.09 4.09 0 0 1-3.798 4.096q-5.266.38-10.128.38-4.885 0-9.77-.383a4.09 4.09 0 0 1-3.759-3.759m-1.633-20.02Q6 21.543 6 26.48q0 4.948.386 9.87a5.73 5.73 0 0 0 5.263 5.262q4.948.388 9.897.388 4.922 0 10.246-.383a5.727 5.727 0 0 0 5.316-5.736q-.017-4.142-.017-9.477c0-3.56.005-6.816.017-9.811a5.727 5.727 0 0 0-5.749-5.706q-5.905.022-9.79.022-3.905 0-9.449-.022a5.727 5.727 0 0 0-5.736 5.316",
      clipRule: "evenodd"
    }
  )
);
var SvgCopyOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CopyOutlined_default = SvgCopyOutlined;

export { CopyOutlined_default as default };
